import { getMessage, getStatusCode } from '@/utils/message_handler';

export default {
  namespaced: true,
  state: {
    error: {
      message: null,
      status: null,
      url: null,
      method: null
    }
  },
  mutations: {
    setError(state, response) {
      if (!response) return;
      state.error.message = getMessage(response);
      state.error.status = getStatusCode(response);
      state.error.url = response.config.url;
      state.error.method = response.config.method;
    },
    clearError(state) {
      state.error = { message: null, status: null };
    }
  }
};
